































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import { SfButton, SfCarousel, SfLink } from '@storefront-ui/vue';

import useUiNotification from '~/composables/useUiNotification';
import { useI18n } from '~/helpers/hooks/usei18n';

export default defineComponent({
  name: 'TopBarCarousel',
  components: {
    SfCarousel,
    SfButton,
    SfLink,
  },
  props: {
    topbarData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { locale } = useI18n();
    const { send: sendNotification } = useUiNotification();
    const {
      app: { i18n },
    } = useContext();
    const context = useContext();
    const onCopy = (text: string) => {
      try {
        // @ts-ignore
        context.$clipboard(text);
        sendNotification({
          id: Symbol('copy_code'),
          message: i18n.t('Copied to Clipboard') as string,
          persist: false,
          type: 'success',
          icon: 'info',
        });
      } catch (err) {
        console.error('Failed to copy text:', err);
      }
    };
    return {
      locale,
      onCopy,
    };
  },
});
